module.exports = __webpack_public_path__ + "264f4a4b036c9a87bee09f4e20929ac6.ttf";